import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { INIT_PAGESIZE } from 'commons/constants';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';
import { message } from 'antd';
import { MSG } from 'commons/constants';

const useSmsTemplate = (pageSize?: number) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [tmpplateList, setTemplateList] = useState<SmsTemplateDto[]>();
  const [searchResult, setSearchResult] = useState({ pageNo: 0, pageSize: pageSize ? pageSize : INIT_PAGESIZE, totalCount: 0 });

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  const searchParams = qs.parse(location.search);
  const { isLoading, refetch } = useQuery(
    [endpoints.emailtemplate.list, location.search],
    () =>
      fetcher.smstemplate.postSmsTemplateList({
        pageNo: Number(searchParams.pageNo) || 1,
        pageSize: Number(searchParams.pageSize) || (pageSize ? pageSize : INIT_PAGESIZE),
        searchValue: searchParams.search ? String(searchParams.search) : '',        
      }),
    {
      onSuccess: (res: SmsTempalteListResDto) => {
        switch (res.code) {
          case 200:
            setTemplateList(res.result?.list);
            setSearchResult({
              pageNo: res.result?.pageNo || 1,
              pageSize: res.result?.pageSize || (pageSize ? pageSize : INIT_PAGESIZE),
              totalCount: res.result?.totalCount || 0,
            });
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  const { mutate: smsTemplateInsert, isSuccess: insertSuccess } = useMutation(
    [endpoints.smstemplate.add],
    fetcher.smstemplate.postSmsTemplateAdd,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_INSERT, 1);
            refetch();
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )

  const { mutate: smsTemplateSave, isSuccess: updateSuccess } = useMutation(
    [endpoints.smstemplate.update],
    fetcher.smstemplate.postSmsTemplateSave,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            refetch();
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )
  
  const { mutate: smsTemplateDelete, isSuccess: deleteSuccess } = useMutation(
    [endpoints.smstemplate.add],
    fetcher.smstemplate.postSmsTemplateDelete,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_DELETE, 1);
            refetch();
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  

  return { isLoading, tmpplateList, searchResult, refetch, smsTemplateInsert, smsTemplateSave, smsTemplateDelete, updateSuccess,  insertSuccess, deleteSuccess  };
};

export default useSmsTemplate;
